export default __webpack_public_path__ + "selected.26ad2584ecbe8e0e92cc4598ef0dd00e.png";